import React, { useEffect, useState } from "react";
import { OrderCard } from "../../components/Cards";
import { getOrders } from "../../configs/ordersConfig";

function Account() {

  const [orders, setOrders] = useState([]);

  const fetchOrders = async () => {
    try {
      const data = await getOrders();
      setOrders(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {

    fetchOrders();
  }, []);




  return (
    <div className="container-lg p-0 d-flex flex-column my-4">


      <h4 className="ms-2">Rendeléseim</h4>
      <div className="d-flex justify-content-center">
        <div className="col-12 col-md-8" >
          {
            orders.map((order, index) => (
              <OrderCard key={index} order={order} onStatusChange={fetchOrders} />
            ))
          }
        </div>

      </div>




    </div>
  );
}

export default Account;
